// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__363-U","title":"PageHeader_title__KCWXS","subtitle":"PageHeader_subtitle__4lRF1"};